import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'weaccess-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Output() buttonClicked = new EventEmitter<string>();
  @Input() class!: string;
  @Input() isDisabled!: boolean;

  /** Button click emit event */
  onButtonClicked() {
    this.buttonClicked.emit('how');
  }
}
